import { render, staticRenderFns } from "./RevisionTable.vue?vue&type=template&id=0d06ebaf&scoped=true"
import script from "./RevisionTable.vue?vue&type=script&lang=js"
export * from "./RevisionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06ebaf",
  null
  
)

export default component.exports